import { apiGet, apiPost } from '@/shared/utils/requestBuilder';

import type {
  ExecucaoEmErro,
  TentarDeNovoArgs,
  TentarDeNovoResultado,
} from '../../types/tentarDeNovo';
import { handleError, unwrapData } from '../services';

const caminhoDoProcesso = (processoId: string) =>
  `/admin/arbitral/processos/${encodeURIComponent(processoId)}`;

export const tentarDeNovoService = {
  listarExecucoesEmErro: async (processoId: string): Promise<ExecucaoEmErro[]> => {
    const response = await apiGet(`${caminhoDoProcesso(processoId)}/execucoes-em-erro`);
    if (!response.ok) await handleError(response, 'Erro ao carregar a etapa que falhou');
    const dados = unwrapData<{ execucoes?: ExecucaoEmErro[] }>((await response.json()) as unknown);
    return Array.isArray(dados?.execucoes) ? dados.execucoes : [];
  },

  tentarDeNovo: async ({
    processoId,
    executionId,
    body,
  }: TentarDeNovoArgs): Promise<TentarDeNovoResultado> => {
    const response = await apiPost(
      `${caminhoDoProcesso(processoId)}/execucoes/${encodeURIComponent(executionId)}/tentar-de-novo`,
      body,
    );
    // `ErroHttp` com a frase do core: 409 de carência ou de corrida, 403 de perfil, 422 de rodada
    // que não iniciou — o diálogo mostra a frase, e a telemetria separa 4xx de 5xx pelo status.
    if (!response.ok) await handleError(response, 'Erro ao tentar de novo');
    return unwrapData<TentarDeNovoResultado>((await response.json()) as unknown);
  },
};
